import React from "react";
import "../css/Clauses.css";
import { clauses } from "../Utils/clauses"

const Clauses = ({ isTouristEvent, minRegistrationsNumber, cancelationTripFinalDate }) => {
  return (
    <div className="clauses">
      {isTouristEvent
        ? clauses.touristEvent(minRegistrationsNumber, cancelationTripFinalDate)
        : clauses.nonTouristEvent()}
    </div>
  );
};

export default Clauses;
